/* eslint-disable */
import {http} from '@/helpers/http';
import {transformDateView} from "@/helpers/transformDates";

const defaultDigital = {
    id: 'new',
    is_active: true,
    updated_at: '',
    name: '',
    alias: '',
    about: '',
    audit: null,
    created_at: '',
    detail_image: null,
    logo: '',
    hide_logo_in_details: false,
    name_preview: '',
    preview_image: null,
    solution: '',
    solution_conclusion: '',
    tasks: '',
    totals: '',
    numbers: [],
    solutions: [],
    stages: [],

    // Вкладка SEO
    seo_title: '',
    seo_description: '',
    seo_keywords: '',
};

const stringToNumber = (obj) => {
    return Object.keys(obj).reduce((newObject, key) => {
        return {...newObject, [key]: Number(obj[key])};
    }, {});
};

export default {
    namespaced: true,
    state() {
        return {
            list: [],
            search: '',
            current: defaultDigital,
        };
    },

    mutations: {
        /* Записать новый список */
        setList(state, data) {
            state.list = data.slice();
        },

        /* Установить поисковое слово */
        setSearch(state, data) {
            state.search = data;
        },

        /* Установить свойство текущего объекта */
        setValue(state, payload) {
            state.current = {
                ...state.current,
                ...payload
            };
        },

        /* Очистить текущее значение */
        clearCurrent(state) {
            state.current = {
                ...state.current,
                ...defaultDigital
            }
        },

        /* Удалить из списка */
        removeFormList(state) {
            const index = state.list.findIndex(({id}) => id === state.current.id);
            state.list.splice(index, 1);
        },

        /* Установить текущий объект по идентификатору */
        setCurrent(state, _id) {
            const promo = state.list.find(({id}) => id === _id)
            state.current = {
                ...state.current,
                ...promo
            }
        },

        /* Заменить по идентификатору */
        replaceById(state, current) {
            const index = state.list.findIndex(({id}) => id === current.id);
            state.list.splice(index, 1, current);
        },

        /* Добавить в список */
        addList(state, current) {
            state.list.push({...current, id: state.list.length + 1});
        }
    },

    getters: {
        // getList: state => state.list.filter(({ title }) => title.indexOf(state.search) >= 0),

        getList: state => state.list
            .filter(({name}) => {
                    return name.toLowerCase().indexOf(state.search.toLowerCase()) >= 0;
                }
            )
            .map(({id, is_active, alias, name, updated_at}) => {
                return {
                    id,
                    name,
                    alias,
                    is_active: is_active ? 'Да' : 'Нет',
                    updated_at: updated_at
                };
            }),

        getItems: state => state.list.map(({id, name}) => {
            return {id, name};
        }),

        getById: state => _id => state.list.find(({id}) => id === _id),

        getCurrent: state => state.current,

        getFormatList: (state, getters) => {
            return getters.getList.map(obj => ({
                ...obj,
                activity: obj.activity ? 'Да' : 'Нет'
            }))
        }
    },

    actions: {
        async getList({commit}) {
            try {
                const {data} = await http.get('/admin/products');
                commit('setList', data);
                console.log('cases getList', data)
            } catch (e) {
                throw e;
            }
        },

        async remove({commit}, id) {
            await http.delete('/admin/products/' + id);
            commit('clearCurrent');
        },

        async getById({commit, rootState, state}, id) {
            if (id === null || id === 'new') {
                commit('clearCurrent');
                return;
            }

            const {data} = await http.get('/admin/products/' + id);

            commit('setValue', {
                id: data.id,
                is_active: data.is_active,
                name: data.name,
                alias: data.alias,
                logo: data.logo,
                hide_logo_in_details: data.hide_logo_in_details,
                detail_image: data.detail_image,
                preview_image: data.preview_image,
                name_preview: data.name_preview,
                about: data.about,
                numbers: data.numbers,
                tasks: data.tasks,
                audit: data.audit,
                totals: data.totals,
                solution: data.solution,
                solution_conclusion: data.solution_conclusion,
                solutions: data.solutions,
                stages: data.stages,

                seo_title: data.seo_description,
                seo_description: data.seo_keywords,
                seo_keywords: data.seo_title,
            });
        },


        async save({state}) {
            // Это новый элемент или редактирование?
            const isNew = state.current.id === 'new' || state.current.id === null;
            let solutions = state.current.solutions.map(solution => ({...solution, ...{items: solution.items.filter(item => !!item.name)}}));

            if (!isNew) {
                const {data: id} = await http.put('/admin/products/' + state.current.id, {
                    id: state.current.id,
                    is_active: state.current.is_active,
                    name: state.current.name,
                    alias: state.current.alias,
                    logo: state.current.logo,
                    hide_logo_in_details: state.current.hide_logo_in_details,
                    detail_image: state.current.detail_image,
                    preview_image: state.current.preview_image,
                    name_preview: state.current.name_preview,
                    about: state.current.about,
                    numbers: state.current.numbers,
                    tasks: state.current.tasks,
                    audit: state.current.audit,
                    totals: state.current.totals,
                    solution: state.current.solution,
                    solution_conclusion: state.current.solution_conclusion,
                    solutions,
                    stages: state.current.stages,

                    seo_title: state.current.seo_description,
                    seo_description: state.current.seo_keywords,
                    seo_keywords: state.current.seo_title,
                });
                return id.id;
            } else {
                const {data: id} = await http.post('/admin/products', {
                    is_active: state.current.is_active,
                    name: state.current.name,
                    alias: state.current.alias,
                    logo: state.current.logo,
                    hide_logo_in_details: state.current.hide_logo_in_details,
                    detail_image: state.current.detail_image,
                    preview_image: state.current.preview_image,
                    name_preview: state.current.name_preview,
                    about: state.current.about,
                    numbers: state.current.numbers,
                    tasks: state.current.tasks,
                    audit: state.current.audit,
                    totals: state.current.totals,
                    solution: state.current.solution,
                    solution_conclusion: state.current.solution_conclusion,
                    solutions,
                    stages: state.current.stages,

                    seo_title: state.current.seo_description,
                    seo_description: state.current.seo_keywords,
                    seo_keywords: state.current.seo_title,
                });
                return id.id;

            }

        }
    },
};
